import { TApplicationState } from '../../types/redux';

export function getHouseId(state: TApplicationState) {
  return state.floorPlan.houseId;
}
